export const COLORS = {
    headerBackground: "#FFFFFF",
    main: "#FBFBFB",
    accent: "#281318",
    whiteText: "#FFFFFF",
    blackText: "#1F1F1F"
}